export const PRIVACY_REQUESTS = {
  CCPA_OPT_OUT_SALE_PI: 'ccpa-opt-out-sale-pi',

  CCPA_GET_CATEGORIES_PI: 'ccpa-get-categories-pi',
  CCPA_GET_SPECIFIC_PI: 'ccpa-get-specific-pi',
  CCPA_DELETE_PI: 'ccpa-delete-pi',
  REQUEST_CORRECTION: 'request-correction',
  APPEAL_REQUEST: 'appeal-request',
};

export const OPT_OUT_REQUEST_TYPE = {
  value: PRIVACY_REQUESTS.CCPA_OPT_OUT_SALE_PI,
  label: 'Opt-Out of Sale and Sharing of Personal Information',
};

export const REQUESTS_TYPES = [
  { value: PRIVACY_REQUESTS.CCPA_DELETE_PI, label: 'Deletion of Personal Information' },
  {
    value: PRIVACY_REQUESTS.CCPA_GET_CATEGORIES_PI,
    label: 'Report of Categories of Personal Information Collected, Used, Shared and Sold',
  },
  {
    value: PRIVACY_REQUESTS.CCPA_GET_SPECIFIC_PI,
    label: 'Copy of Specific Pieces of Personal Information',
  },
  { value: PRIVACY_REQUESTS.REQUEST_CORRECTION, label: 'Request Correction' },
  { value: PRIVACY_REQUESTS.APPEAL_REQUEST, label: 'Appeal Prior Data Privacy Request' },
];

export const IDENTITIES = {
  CONSUMER: 'consumer',
  AUTHORIZED_AGENT: 'authorized agent',
};

export const REQUESTS_REQUIRE_COMMENT = new Set([PRIVACY_REQUESTS.REQUEST_CORRECTION, PRIVACY_REQUESTS.APPEAL_REQUEST]);

export const IDENTITY_OPTIONS = [
  { value: IDENTITIES.CONSUMER, label: 'Consumer' },
  { value: IDENTITIES.AUTHORIZED_AGENT, label: 'Authorized Agent of a Consumer' },
];

export const DATA_PRIVACY_FORM_FIELDS = {
  REQUEST_TYPE: 'requestType',
  REQUEST_DESCRIPTION: 'request-description',
  IDENTITY: 'identity',
  IS_EMPLOYMENT_AFFILIATION: 'isEmploymentAffiliation',
  IS_BUSINESS_AFFILIATION: 'isBusinessAffiliation',
  AGENT_EMAIL: 'aem',
  AGENT_FIRST_NAME: 'afn',
  AGENT_LAST_NAME: 'aln',
  AGENT_PHONE: 'aph',
  AGENT_ADDRESS: 'aa',
  AGENT_CITY: 'ac',
  AGENT_STATE: 'as',
  AGENT_ZIP: 'azip',
  CONSUMER_EMAIL: 'uem',
  CONSUMER_FIRST_NAME: 'ufn',
  CONSUMER_LAST_NAME: 'uln',
  CONSUMER_PHONE: 'uph',
  CONSUMER_ADDRESS: 'ua',
  CONSUMER_CITY: 'uc',
  CONSUMER_STATE: 'us',
  CONSUMER_ZIP: 'uzip',
};

export const DPR_API_URL = 'https://dpr-api.edmunds.com';

export const SUBMIT_PARAM = 'submit';
